export default "<div *ngIf=\"title\" class=\"chart__title chart__title--heatmap\">{{ title }}</div>\n<div class=\"chart__wrap chart__wrap--heatmap\"></div>\n";